<template>
  <div class="edit-modal" ref="userEditModal">
    <artmisads-modal
      :footer="null"
      :open="visible"
      title="Edit"
      :width="480"
      :mask-closable="false"
      :getContainer="() => $refs.userEditModal"
      @cancel="handleCancel"
    >
      <div class="modal-content">
        <a-form
          :model="formState"
          ref="editFormRef"
          name="basic"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
          autocomplete="off"
        >
          <a-form-item
            v-if="actionType=='1'"
            label="Select Brand"
            name="brandId"
            :rules="[
              { required: true, message: 'Please select a brand!' },
            ]"
          >
            <a-select 
              v-model:value="formState.brandId" 
              placeholder="Select a brand"
              :show-search="true"
              :virtual="true"
              :not-found-content="!loading ? 'No data found' : 'Loading...'"
              :filter-option="false"
              @search="handleSearch"
              @popupScroll="handlePopupScroll"
            >
              <a-select-option v-for="item in brandList" :key="item.value" :value="item.value">{{ item.label }}({{ item.sellerName }})</a-select-option>
            </a-select>
          </a-form-item>
          <!-- <a-form-item
            label="entityId"
            name="ccEntityId"
            :rules="[{ required: true, message: 'Please input your entityId!' }]" 
            v-if="actionType=='0'"
          >
            <a-input v-model:value="formState.ccEntityId" />
          </a-form-item> -->
        </a-form>
      </div>
      <div class="modal-footer">
        <a-button @click="handleCancel">Cancel</a-button>
        <a-button type="primary" @click="handleSubmit">Submit</a-button>
      </div>
    </artmisads-modal>
  </div>
</template>
<script setup lang="js">
import { ref,defineExpose,nextTick} from 'vue'
import { creatorConnectionsApi } from '@/server/operator/creatorConnections'
import { message, Modal } from 'ant-design-vue'
import { refresh } from 'less'
const emit = defineEmits(['save']);
const visible = ref(false)
const editFormRef = ref(null)
const actionType = ref('')
const formState = ref({
  brandId: '',
  ccEntityId: '',
})
// 分页相关状态
const brandList = ref([])
const loading = ref(false)
const currentPage = ref(1)
const pageSize = ref(20)
const hasMore = ref(true)
const currentSellerId = ref('')
const currentMarketplace = ref('')
const searchValue = ref('')
const authorizeId=ref('')
const openModal = (type,record) => {
  visible.value = true
  actionType.value=type
  authorizeId.value=record.id

  
  formState.value={
   brandId: '',
   ccEntityId: '',
  }

  // 重置分页状态
  brandList.value = []
  currentPage.value = 1
  hasMore.value = true
  searchValue.value = ''
   if(type=='1'){
    currentSellerId.value = record.sellerId
    currentMarketplace.value = record.marketplace
    getBrandList(record.sellerId, record.marketplace, 1, searchValue.value)
  }
 nextTick(()=>{
  editFormRef.value.resetFields()
 })
}

const handleCancel = () => {
  visible.value = false
}

// 分页获取品牌列表
const getBrandList=async (id, marketplace, page, searchText)=>{
  // 如果已经没有更多数据或已经在加载中，则不再请求
  if (!hasMore.value || loading.value) return
  loading.value = true
  try {
    let data=await creatorConnectionsApi.brandSearch({
      page: page,
      size: pageSize.value,
      sellerId: id,
      marketplace: marketplace,
      keyword: searchText // 添加搜索关键词
    })
    
    if(data.success){

      const newBrandList = data.data.map(item=>({
        label: item.amazonBrandName,
        value: item.id,
        sellerName: item.amazonName,
      }))
   
      // 如果是第一页，则替换列表，否则追加
      if (page === 1) {
        brandList.value = newBrandList
      } else {
        brandList.value = [...brandList.value, ...newBrandList]
      }
      
      // 判断是否还有更多数据
      // hasMore.value = newBrandList.length !== data.data.total
      currentPage.value = page
    } else {
     
      if (page === 1) {
        brandList.value = []
      }
    }
  } catch (error) {
    
    message.error('Failed to fetch brand list')
  } finally {
    loading.value = false
  }
}

// 处理搜索
const handleSearch = (value) => {
  searchValue.value = value
  currentPage.value = 1
  brandList.value = []
  hasMore.value = true
  getBrandList(currentSellerId.value, currentMarketplace.value, 1, value)
}

// 处理下拉滚动到底部，加载更多
const handlePopupScroll = (e) => {
  const { target } = e
  const scrollHeight = target.scrollHeight
  const scrollTop = target.scrollTop
  const clientHeight = target.clientHeight
  
  // 当滚动到底部附近时，加载下一页
  if (scrollHeight - scrollTop - clientHeight < 100 && hasMore.value && !loading.value) {
    getBrandList(currentSellerId.value, currentMarketplace.value, currentPage.value + 1, searchValue.value)
  }
}

const handleSubmit = () => {
  editFormRef.value.validate().then((valid) => {
    if (valid) {
      Modal.confirm({
        title: 'Are you sure you want to submit?',
        okText: 'Yes',
        okType: 'danger',
        onOk: () => {
          // 确认提交
          if(actionType.value=='1'){
        creatorConnectionsApi.syncConnection({
          id:authorizeId.value,
          confirmedBrandId:formState.value.brandId
        }).then(res=>{
         if(res.success){
           message.success('success')
           emit('refresh')
           visible.value=false
         }
         else{
          message.error(res.error)
         }
        })
        // .finally(()=>{
        //   emit('refresh')
        // })
      }else{
        creatorConnectionsApi.authorizeConnection({
          id:authorizeId.value,
          ccEntityId:formState.value.ccEntityId,

        }).then(res=>{
         if(res.success){
           message.success('success')
           emit('refresh')
           visible.value=false
         }
         else{
          message.error(res.error)
         }
        })

      }
        },
        onCancel: () => {
          // 取消提交
        },
      });
     
      
    } else {
      console.log('Validation failed')
    }
  })
}

defineExpose({
  openModal
})
</script>
<style scoped lang="less">
.edit-modal {
  .modal-content {
    
  }
  .modal-footer{
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
    gap: 10px;
    border-top: 1px solid #e8e8e8;
  }
}
</style>
